import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
} from '@material-ui/core';
import { Add as AddIcon, Edit as EditIcon } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { PageFilter } from '../../../state/app';
import { AppState } from '../../../state/configureStore';
import {
  clearSampleDevelopmentHl,
  fetchSampleDevelopmentHlList,
  SampleDevelopmentHlState,
  SampleDevelopmentHlListFilter,
} from '../../../state/sampleDevelopmentHl';
import {
  PageContainer,
  PageTitle,
  TableLoading,
  PageButtonGroup,
  DateTimeDisplay,
  SortLabel,
} from '../../components';
import { useFilter, useTableSorting } from '../../hooks';
import { SampleDevelopmentStatusLabel } from '../../../constants/sampleDevelopmentStatus';
import SampleDevelopmentHlFilter from './SampleDevelopmentHlFilter';

const initialSampleDevelopmentHlListFilter: SampleDevelopmentHlListFilter = {
  'Status.equalsTo': '',
};

const SampleDevelopmentHlList: React.FC<RouteComponentProps> = (props) => {
  const dispatch = useDispatch();
  const { history } = props;
  const [filters, setFilters] = useFilter<SampleDevelopmentHlListFilter>(
    initialSampleDevelopmentHlListFilter,
  );

  const [sort, setSort] = useTableSorting({
    orderBy: 'sampleDevNumber',
    direction: 'desc',
  });

  const [paging, setPaging] = useState<PageFilter>({
    pageNumber: 0,
    pageSize: 15,
  });

  const { items: sampleDevelopmentHlList, totalItems, loading } = useSelector<
    AppState,
    SampleDevelopmentHlState
  >((state) => state.sampleDevelopmentHl);

  const handleChangeFilter = (newFilter: SampleDevelopmentHlListFilter): void => {
    setFilters(newFilter);
    setPaging({
      ...paging,
      pageNumber: 0,
    });
  };

  const handleChangePageNumber = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number,
  ) => {
    setPaging({ ...paging, pageNumber: newPage });
  };

  const handleChangePageSize = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setPaging({
      ...paging,
      pageSize: +event.target.value,
      pageNumber: 0,
    });
  };

  useEffect(() => {
    dispatch(fetchSampleDevelopmentHlList(filters, { ...paging, sort }));
    return function cleanUp() {
      dispatch(clearSampleDevelopmentHl());
    };
  }, [dispatch, paging, filters, sort]);

  const addNewSampleDevelopmentHl = (): void => {
    history.push('/sampleDevelopmentHl/form');
  };

  const editSampleDevelopmentHl = (id: number): void => {
    history.push(`/sampleDevelopmentHl/form/${id}`);
  };

  return (
    <PageContainer>
      <PageTitle>Sample Development HL</PageTitle>
      <SampleDevelopmentHlFilter
        filters={filters}
        onChangeFilter={handleChangeFilter}
        initialFilter={initialSampleDevelopmentHlListFilter}
      />
      <PageButtonGroup>
        <Button
          variant="contained"
          color="primary"
          onClick={addNewSampleDevelopmentHl}
          startIcon={<AddIcon />}
        >
          New Sample Development HL
        </Button>
      </PageButtonGroup>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>No.</TableCell>
            <TableCell>
              <SortLabel sort={sort} handleSortChange={setSort} field="sampleDevNumber">
                Running Number
              </SortLabel>
            </TableCell>
            {/* <TableCell>Status</TableCell> */}
            <TableCell>Program</TableCell>
            {/* <TableCell>Brand</TableCell> */}
            <TableCell>Item</TableCell>
            <TableCell>Block</TableCell>
            <TableCell>Created At</TableCell>
            <TableCell>Created By</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableLoading isLoading={loading} colSpan={10}>
            {sampleDevelopmentHlList.map((sampleDevelopmentHl, index) => (
              <TableRow key={sampleDevelopmentHl.id}>
                <TableCell>{index + paging.pageSize * paging.pageNumber + 1}</TableCell>
                <TableCell>{sampleDevelopmentHl.sampleDevNumber}</TableCell>
                {/* <TableCell>
                  {SampleDevelopmentStatusLabel[sampleDevelopmentHl.status!]}
                </TableCell> */}
                <TableCell>{sampleDevelopmentHl.block?.program?.name}</TableCell>
                {/* <TableCell>{sampleDevelopmentHl.block?.brand?.name}</TableCell> */}
                <TableCell>{sampleDevelopmentHl.block?.item}</TableCell>
                <TableCell>{sampleDevelopmentHl.block?.blockNo}</TableCell>
                <TableCell>
                  <DateTimeDisplay value={sampleDevelopmentHl.createdAt} />
                </TableCell>
                <TableCell>{sampleDevelopmentHl.createdBy}</TableCell>
                <TableCell>
                  <Tooltip title={'Edit'}>
                    <span>
                      <IconButton
                        size="small"
                        onClick={() => editSampleDevelopmentHl(sampleDevelopmentHl.id!)}
                      >
                        <EditIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableLoading>
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[15, 25, 35]}
        component="div"
        count={totalItems}
        rowsPerPage={paging.pageSize}
        page={paging.pageNumber}
        onPageChange={handleChangePageNumber}
        onRowsPerPageChange={handleChangePageSize}
      />
    </PageContainer>
  );
};

export default SampleDevelopmentHlList;
